import { createActions, createReducer } from 'reduxsauce';

import { updateProp, updateProps } from 'Reducers/shared';

export const { Types, Creators } = createActions(
  {
    updateProp: ['key', 'value'],
    updateProps: ['props'],
    alert: ['body', 'client', 'kind', 'persist', 'title', 'buttons', 'rest']
  },
  { prefix: 'growl/' }
);

const initialState = {
  body: '',
  buttons: [],
  client: null,
  kind: '',
  title: '',
  visible: false,
  rest: null
};

export const alert = (state, action) => ({
  ...state,
  body: action.body || '',
  buttons: action.buttons || [],
  client: action.client,
  kind: action.kind || 'info',
  title: action.title || '',
  visible: true,
  rest: action.rest || null
});

export const growl = state => state.growl;

export default createReducer(initialState, {
  [Types.UPDATE_PROP]: updateProp,
  [Types.UPDATE_PROPS]: updateProps,
  [Types.ALERT]: alert
});
